import appConfig from '@/utils/appConfig'

export const featureAccess = (featureName) => {
    return appConfig[`VUE_APP_FEATURE_${featureName}`]
}

export const isExceptionStatus = (status) => {
    const exceptionsStatusesList = [501]

    return exceptionsStatusesList.find(item => item === status)
}
